export default "__VITE_ASSET__BAmrDYEJ__"